interface Props {
  type: 'success' | 'error' | 'warn';
  message: string;
}

const SYMBOLS: Record<Props['type'], string> = {
  success: '✓',
  error: '✗',
  warn: '⚠',
};

/** Inline status banner (success/error/warn) with ARIA live region semantics. */
export function Feedback({ type, message }: Props) {
  return (
    <div
      className={`feedback ${type}`}
      role={type === 'error' ? 'alert' : 'status'}
      aria-live={type === 'error' ? 'assertive' : 'polite'}
    >
      {SYMBOLS[type]} {message}
    </div>
  );
}
